import React from 'react';
import {
  AutocompleteInput,
  BooleanInput,
  Create,
  LongTextInput,
  ReferenceInput,
  SimpleForm,
  TextInput
} from 'react-admin';

export const CreateApnsPlatform = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="bundleId" />
      <ReferenceInput
        label="Applications"
        source="id"
        reference="selectable-applications"
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <BooleanInput source="enabled" />
      <BooleanInput source="develop" />
      <LongTextInput source="certificate" title="title" />
    </SimpleForm>
  </Create>
);
